import { rowEntries } from './auditPresentation';

/** The finding's row as extracted, the questioned field marked; "Row moved" when the row is no longer there. */
export function AuditExtractedRow({ row, rowMoved, field }: { row: Record<string, unknown> | null; rowMoved: boolean; field: string }) {
  if (rowMoved)
    return (
      <p className="text-sm text-amber-700 dark:text-amber-400">
        Row moved: the extraction no longer holds this row, so it is not shown.
      </p>
    );
  if (!row) return null;
  return (
    <table className="w-full text-sm">
      <tbody>
        {rowEntries(row, field).map((e) => (
          <tr
            key={e.key}
            data-highlighted={e.highlighted}
            className={e.highlighted ? 'bg-amber-50 font-medium dark:bg-amber-500/10' : undefined}
          >
            <td className="py-0.5 pr-4 align-top font-mono text-gray-500 dark:text-zinc-400">{e.key}</td>
            <td className="py-0.5 break-all text-gray-900 dark:text-zinc-100">{e.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
